/* eslint-disable */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useUser } from "../../../common-hooks/user";
import {
  resetPostFilter,
  setPostFilter,
  getPosts,
  updatePostStatus,
} from "./action";
import { MENTION_TYPES } from "./constant";
import {
  getPostsFilters,
  getPosts as getTotalPosts,
  getCount,
} from "./selectors";

export const usePosts = (props) => {
  const dispatch = useDispatch();
  const filters = useSelector(getPostsFilters);
  const posts = useSelector(getTotalPosts);
  const count = useSelector(getCount);
  const user = useSelector(({ authReducer }) => authReducer?.loggedInUser);
  const history = useHistory();
  const { isAdmin, isModerator, isCSSpecialist } = useUser();

  const [loadingPosts, setLoadingPosts] = useState(false);

  useEffect(() => {
    setLoadingPosts(true);
    const fetchPosts = async () => {
      try {
        const data = await dispatch(getPosts(filters));
        if (data?.is_success) {
          setLoadingPosts(false);
        }
      } catch (error) {
        setLoadingPosts(false);
      } finally {
        setLoadingPosts(false);
      }
    };
    fetchPosts();
  }, [filters, dispatch]);

  const setFilter = (key, value) => {
    dispatch(setPostFilter({ key, value }));
  };

  const resetFilter = async () => {
    dispatch(resetPostFilter());
  };

  const updatePostsStatus = async (id, payload) => {
    const { is_success } = await dispatch(updatePostStatus(id, payload));
    if (is_success) {
      await dispatch(getPosts(filters));
    }
  };

  const publishStatus = async (id) => {
    const { is_success } = await dispatch(
      updatePostStatus(id, { status: "Published", reason: "" })
    );

    if (is_success) {
      await dispatch(getPosts(filters));
    }
  };

  const hashtagClick = (e) => {
    e.target.id && setFilter("hashtag", e.target.id?.split("#")[1]);
  };

  const handleReportClick = (e) => {
    history.push(`/post/${e.target.id}/reports`);
  };

  return {
    filters,
    setFilter,
    resetFilter,
    posts,
    count,
    user,
    updatePostsStatus,
    loadingPosts,
    hashtagClick,
    publishStatus,
    isAdmin,
    isModerator,
    isCSSpecialist,
    handleReportClick,
  };
};
